import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import dataService from 'services/dataService';

import PageContainer from 'components/common/PageContainer';
import AppPageHeader from 'components/common/AppPageHeader';
import PageRow from 'components/common/PageRow';
import CustomersList from './components/CustomersList';
import MonthlyRevenue from './components/MonthlyRevenue';

const AdminContainer = styled(PageContainer)`
  position: relative;
`;

const ImageContainer = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 92.4rem;
  background: url(/images/mountain.svg) no-repeat;
  background-position: bottom;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const Image = styled.div`
  width: 44.6rem;
  height: 40.2rem;
  background: url(/images/moped.svg) no-repeat;
  margin-right: 3.8rem;
`;

function AdminPage() {
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    initData();
  }, []);

  async function initData() {
    let data = await dataService.getAdminData();

    if (!_.isEmpty(data)) {
      setCustomers(data.customers || []);
      setTotal(data.revenue.total || 0);
    }
  }

  return (
    <AdminContainer>
      <AppPageHeader title="Admin" />

      <PageRow>
        <CustomersList customers={customers} />

        <MonthlyRevenue total={total} />
      </PageRow>

      <ImageContainer>
        <Image />
      </ImageContainer>
    </AdminContainer>
  );
}

export default AdminPage;
